import { graphql } from 'src/graphql';

export const AIModeratedTaskBlock = graphql(`
  fragment AIModeratedTaskBlock on AIModeratedTaskBlock @_unmask {
    __typename
    _id
    type
    title
  }
`);

export const AIModeratedTaskBlockResearchGoal = graphql(`
  fragment AIModeratedTaskBlockResearchGoal on AIModeratedTaskBlockResearchGoal @_unmask {
    research_goal {
      goal
      depth
    }
  }
`);

export const AIModeratedTaskBlockLiveWebsiteTest = graphql(`
  fragment AIModeratedTaskBlockLiveWebsiteTest on AIModeratedTaskBlockLiveWebsiteTest @_unmask {
    live_website_test {
      task
      url
    }
  }
`);

export const AIModeratedTaskBlockNoviceExpertWebsiteTest = graphql(`
  fragment AIModeratedTaskBlockNoviceExpertWebsiteTest on AIModeratedTaskBlockNoviceExpertWebsiteTest @_unmask {
    live_website_test {
      task
      url
    }
    novice_persona_brief {
      summary
      concerns {
        area
        description
        priority
      }
      constraints
      preferences
      decision_drivers
      emotional_context
    }
    _novice_booking_id
    _novice_participant_id
  }
`);
